<template>
  <table>
    <thead>
      <th>Datum</th>
      <th>Hafen</th>
      <th>Land/Insel</th>
      <th>Ankunft</th>
      <th>Abfahrt</th>
    </thead>
    <tbody>
      <tr 
        v-for="(segment, index) in segments" 
        :key="index"
      >
        <td width="100px">
          {{ formatDate(segment.day) }}
        </td>
        <td>{{ isOcean(segment) ? 'Seetag' : 'portName' in segment ? segment.portName : '' }}</td>
        <td>{{ isOcean(segment) ? '' : 'country' in segment ? segment.country : '' }}</td>
        <td width="90px">
          {{ !isOcean(segment) && 'arrivalTime' in segment && segment.arrivalTime ? segment.arrivalTime + ' Uhr' : '' }}
        </td>
        <td width="90px">
          {{
            !isOcean(segment) && 'departureTime' in segment && segment.departureTime
              ? segment.departureTime + ' Uhr'
              : ''
          }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { useCruiseStore } from '@/store'
import { Days2Segments, DetailJourneySegment } from '@/store/details/cruise/interfaces'
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { convertFormat, DEFAULT_DATE_FORMAT, DEFAULT_DATE_FORMAT_WITH_WEEKDAY } from '../../../general/helper'

export default defineComponent({
  computed: {
    ...mapState(useCruiseStore, {
      route: store => store.route,
    }),
    segments(): Days2Segments {
      return this.route?.segments ?? []
    },
  },
  methods: {
    formatDate: (date: string) => {
      return convertFormat(date, DEFAULT_DATE_FORMAT, DEFAULT_DATE_FORMAT_WITH_WEEKDAY)
    },

    isOcean: (segment: DetailJourneySegment) => {
      return 'ocean' in segment && segment.ocean
    },
  },
})
</script>

<style lang="scss" scoped>
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  border-bottom: 1px solid $color-expinet-blue;
}

tr {
  border-bottom: 1px solid $color-expinet-gray;
}
</style>
